import { RematchDispatch, RematchRootState } from '@rematch/core';
import { connect } from 'react-redux';
import { RootModel } from '../../../state';
import { DefaultRouteSelectionContainer } from './DefaultRouteSelectionContainer';

export const mapState = (state: RematchRootState<RootModel>) => ({
  service: state.services.service,
  defaultRoute: state.services.defaultRoute,
  tabIsDefault: state.connections.tabIsDefault,
});

export const mapDispatch = (dispatch: RematchDispatch<RootModel>) => ({
  setDefaultRoute: (tabRoute: string) =>
    dispatch.services.setDefaultRoute(tabRoute),
  setTabIsDefault: (value: boolean) =>
    dispatch.connections.setTabIsDefault(value),
  loadConnections: async () => dispatch.connections.loadConnections({}),
  loadTabIsDefault: async () => dispatch.connections.loadTabIsDefault({}),
});

export const ConnectedDefaultRouteSelection = connect(
  mapState,
  mapDispatch
)(DefaultRouteSelectionContainer);
